import { phoneSystem } from './in-app-browser.js';

/**
 * WHICH PHONE THIS IS, BEFORE THE BODY EXISTS (17 October 2026).
 *
 * A phone held upright meets the rotate screen, and a phone whose rotation is
 * locked stays upright however it is turned. Under the screen's paragraph one
 * line names that lock in the words the phone's own settings use: an iPhone's
 * Control Center calls it Portrait Orientation Lock, an Android's Quick
 * Settings call it Auto-rotate (index.html `#rotate-overlay-lock`).
 *
 * This marks `<html data-phone-os="ios|android">`, and responsive.css shows the
 * matching line. It rides in the head bundle (dist/app.pre1.js), so the mark is
 * there before the screen is parsed and the right line is on the first paint;
 * a line chosen any later would be swapped in under the visitor. Anything that
 * is not a phone (a tablet, which turns, or a desktop window made narrow) gets
 * no mark, and the plain line.
 *
 * Which phone is in-app-browser.js `phoneSystem`, the same reading of the user
 * agent the in-app card uses.
 * Contract: tests/unit/client/phoneOsFlag.test.js.
 */
(function () {
  'use strict';

  let os = null;
  try {
    os = phoneSystem(window.navigator.userAgent);
  } catch (_) {
    os = null;
  }
  if (os) document.documentElement.setAttribute('data-phone-os', os);
}());
